import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import MaterialIcon from "shared/react_components/MaterialIcon";
import { searchInput, searchInputIcon, searchButton } from "./actionPanelStyles.module.scss";
import DebouncedInput from "../DebouncedInput";

export default function SearchDisplay({ searchAction, searchValue, children }) {
  return (
      <>
        <div className="col-auto mr-auto align-middle pl-0">
          <MaterialIcon name="search" className={searchInputIcon}/>
          <DebouncedInput
            className={searchInput}
            aria-label="Search"
            type="input"
            defaultValue={searchValue}
            onChange={searchAction}
            timeout={500}
          />
        </div>

        <div className={classNames("col-auto", "align-middle", "pr-0", searchButton)}>
          {children}
        </div>
      </>
  );
}

SearchDisplay.propTypes = {
  searchAction: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  children: PropTypes.node
};

SearchDisplay.defaultProps = {
  searchValue: null,
  children: null
};
